module.exports = __webpack_public_path__ + "static/img/901.a95ab446.png";